import type { StudentTrainingListItem } from '../services/StudentTrainingService';
import { formatStudentTrainingStatus, type TrainingCategory, type TrainingItem } from '../types/training';
import { formatDate, formatText } from './formatting';

const DEFAULT_SUMMARY_VALUE = '—';

const uniqueNames = (names: string[]): string[] => {
  const seen = new Set<string>();
  const unique: string[] = [];

  names.forEach((rawName) => {
    const name = rawName.trim();
    const key = name.toLocaleLowerCase('pt-BR');
    if (!name || seen.has(key)) {
      return;
    }

    seen.add(key);
    unique.push(name);
  });

  return unique;
};

export const getStudentTrainingsTabPath = (studentId: string | number) => (
  `/alunas/${studentId}/editar?section=trainings`
);

export const mapStudentTrainingListItemToTrainingItem = (
  item: StudentTrainingListItem,
): TrainingItem => {
  const blocks = item.blocks ?? [];

  return {
    id: item.id,
    code: item.code || null,
    name: item.name,
    category: item.category as TrainingCategory,
    status: formatStudentTrainingStatus(item.status),
    splits: blocks.map((block) => block.label).filter(Boolean),
    loadIntensity: DEFAULT_SUMMARY_VALUE,
    effortPerception: DEFAULT_SUMMARY_VALUE,
    deliveredByName: formatText(item.deliveredByName, DEFAULT_SUMMARY_VALUE),
    deliveredAt: item.deliveredAt ? formatDate(item.deliveredAt) : DEFAULT_SUMMARY_VALUE,
    totalVolume: DEFAULT_SUMMARY_VALUE,
    descriptionLabel: item.code ? 'Código' : 'Treino',
    description: item.code ? item.code.toLocaleUpperCase('pt-BR') : item.name,
    group: uniqueNames(blocks.flatMap((block) => block.muscleGroups ?? [])).join(' • ') || 'Não informado',
    durationMinutes: item.durationMinutes,
  };
};
